import React from 'react';
import { Col, Container, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { CommonButton } from '../../CommonComponents';

import { Survey } from 'survey-react-ui';

// Default V2 theme
import 'survey-core/defaultV2.min.css';
// import '../../../../node_modules/survey-core/defaultV2.css';

// Modern theme
// import 'survey-core/modern.min.css';

import './SurveyModal.css';
import CustomSpinner from '../../CustomSpinner/CustomSpinner';

const SurveyModal = ({ isOpen, toggle, modalTitle, modalData,  isMdalLoading}) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} centered className="marketSurveyModal" id="marketSurveyModal" scrollable={true}>
            {isMdalLoading && <CustomSpinner />}
            <ModalHeader className='customModalHeader'>{modalTitle}</ModalHeader>
            <ModalBody className='pl-0 pr-0 pb-0'>
                <Container>
                    <Row>
                        <Col xs={12}>
                            <Survey model={modalData} />
                        </Col>
                    </Row>
                </Container>
            </ModalBody>
            <ModalFooter className='pt-0 pb-0'>
                <CommonButton name={'Close'} btnClass={'btnSecondary'} type="button" onClick={toggle} />
            </ModalFooter>
        </Modal>
    )
}

export default SurveyModal;
